export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
export const showNotification = (message) => ({
    message,
    notificationType: 'normal',
    type: SHOW_NOTIFICATION,
});
export const showAlert = (message) => ({
    message,
    notificationType: 'alert',
    type: SHOW_NOTIFICATION,
});
export const hideNotification = () => ({
    type: HIDE_NOTIFICATION,
});
